<h1 class="auth-status-heading">
  {{'auth.password_reset.reset_confirmation.title' | translate}}</h1>
<app-spinner></app-spinner>
